import { z } from 'zod';

import { DelinquentInterestSettingId } from '../BrandedIds';
import { InvestorRemittanceSplit } from '../loan/InvestorRemittanceSplit';
import { zodBrandedUuid, zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateDelinquentInterestRateEvent = BaseLoanEvent.extend({
  type: z.literal('updateDelinquentInterestRate'),
  delinquentInterestSettingId: zodBrandedUuid<DelinquentInterestSettingId>().optional(),
  delinquentInterestRate: z.number(),
  effectiveDate: zodDateOrString,
  endDate: zodDateOrString.optional(),
  delinquentInterestDeferred: z.boolean().optional(),
  delinquentInterestWaived: z.boolean().optional(),
  investorRemittanceSplit: InvestorRemittanceSplit.optional(),
  comment: z.string().optional(),
});

export type UpdateDelinquentInterestRateEvent = z.infer<typeof UpdateDelinquentInterestRateEvent>;
